import { GET_CAR, GET_CARFACILTIES } from "resources/actionTypes";

export function getCar(data, type, setFilterValues, filterValues) {
  
  const payloadData = {
    data: data,
    type: type,
    setFilterValues: setFilterValues,
    filterValues: filterValues,
  };
  return {
    type: GET_CAR.GET_CAR_REQUESTED,
    payload: payloadData,
  };
}

export function clearCar() {
  return {
    type: GET_CAR.GET_CAR_CLEAR,
  };
}

export function getCarFacilities(data) {
  
  const payloadData = {
    data: data,
  };
  return {
    type: GET_CARFACILTIES.GET_CARFACILTIES_REQUESTED,
    payload: payloadData,
  };
}

